import { AxiosPromise } from 'axios';
import BaseApi from '../base';
import API from '../../types/api';

const HealthCheckAPI = {
  get(opts?: API.RequestOptions): AxiosPromise {
    return BaseApi.get('/health_check', opts || {});
  },
}

export default HealthCheckAPI;
